const pHYs = 0x70485973;
const meter = 0x01;

/**
 * 尝试查找并返回 PNG 文件的 DPI
 * @see http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.pHYs
 *
 * 1x 图返回 96
 * 2x 图返回 144
 * 找不到返回 0
 * @param {File} file
 */
export function readPNGDensity(file) {
	return new Promise((resolve, reject) => {
		if (!/png/i.test(file.type)) {
			return resolve(0);
		}
		const reader = new FileReader();
		reader.onload = () => {
			const view = new Uint8ClampedArray(reader.result);
			const length = view.length;
			const readInt32 = (view, i) => {
				let int32Value = view[i++];
				int32Value = (int32Value << 8) | view[i++];
				int32Value = (int32Value << 8) | view[i++];
				int32Value = (int32Value << 8) | view[i++];
				return int32Value;
			};
			let dpi = 0;
			let i = 0, iPHYs = 0;
			while (i < length) {
				const value = readInt32(view, i);
				if (value === pHYs) {
					break;
				}
				i++;
			}
			let xDensity = readInt32(view, i + 4);
			let yDensity = readInt32(view, i + 8);
			let meter = view[i + 8];
			if (xDensity && yDensity && xDensity === yDensity) {
				switch (xDensity) {
					case 0x1625: dpi = 144; break;
					case 0x0EC3: dpi = 96; break;
				}
			}
			resolve(dpi);
		};
		reader.readAsArrayBuffer(file);
	});
}



// WEBPACK FOOTER //
// ./lib/helpers/readPNGDensity.js